import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IonText } from '@ionic/angular/standalone';

import { IconNames } from '../../../shared';
import { SvgIconComponent } from '../../icons/svg-icon/svg-icon.component';
import { ButtonComponent } from '../button/button.component';

@Component({
    selector: 'lib-input-button',
    standalone: true,
    imports: [IonText, CommonModule, ButtonComponent, SvgIconComponent],
    templateUrl: './input-button.component.html',
    styleUrl: './input-button.component.css'
})
export class InputButtonComponent {
    /* eslint-disable */
    @Input() id: string | undefined;
    @Input() placeholder: string | undefined;
    @Input() value: string | number | null | undefined;
    @Input() iconName: IconNames | undefined;
    @Input() disabled: boolean = false;
    @Input() dateTimeFormat: string | undefined;
    @Input() label: string | undefined;
    @Input() expand: boolean = true;
    @Input() readonly: boolean = false;

    @Input() allowTextOverflow: boolean = false;

    @Output() onButtonClick = new EventEmitter();

    onClick() {
        if (this.disabled || this.readonly) return;
        this.onButtonClick.emit();
    }
}
